/**
 * **特殊召喚（宣言）**（Issue #589）。イベントの中身は `code` と出る場所だけなので、**直前の素材の `move`**
 * （理由 SYNCHRO / FUSION / RITUAL / XYZ / LINK）で種類を決める。素材と召喚は応答（op）をまたぐ
 * （実データで op 8 → 10）ので、窓は「直前の召喚（成功）・フェイズ・ターンまで」。素材が無ければ `plain`（効果などによる特殊召喚）。
 * 事実: `materials`（素材の move の payload。古い順）/ `materialCount`。出る場所が無ければ null
 */
export const VARIANTS = Object.freeze([
  { name: 'plain', label: '特殊召喚（素材なし）' },
  { name: 'synchro', label: 'シンクロ召喚' },
  { name: 'fusion', label: '融合召喚' },
  { name: 'ritual', label: '儀式召喚' },
  { name: 'xyz', label: 'エクシーズ召喚' },
  { name: 'link', label: 'リンク召喚' },
]);

const UNTIL = Object.freeze(['summoned', 'spsummoned', 'flipsummoned', 'new_phase', 'new_turn']);

export default Object.freeze({
  event: 'spsummoning',
  variants: VARIANTS,
  classify({ payload, history }) {
    if (!payload?.zone) return null;
    const mats = history?.run?.('move', { until: UNTIL, filter: (p) => p.isMaterial }) ?? [];
    const kind = mats.map((m) => m.payload?.materialKind).find(Boolean) ?? null;
    return {
      ...payload,
      variant: kind && VARIANTS.some((v) => v.name === kind) ? kind : 'plain',
      materials: mats.map((m) => m.payload),
      materialCount: mats.length,
    };
  },
});
